import { usePym } from '@telescope/cassini-hooks';
import { useCallback, useEffect, useState } from 'react';

// parses the position info message from the parent into a usable object
const parseParentInfo = (info: string) => {
  var infoArray = info.split(' ');
  var infoObj = {
    vWidth: parseFloat(infoArray[0]),
    vHeight: parseFloat(infoArray[1]),
    iframeTop: parseFloat(infoArray[2]),
    iframeLeft: parseFloat(infoArray[3]),
    iframeBottom: parseFloat(infoArray[4]),
    iframeRight: parseFloat(infoArray[5]),
  };

  return infoObj;
};

export const useParentPosition = () => {
  const [parentInfo, setParentInfo] = useState({
    vWidth: 0,
    vHeight: 0,
    iframeTop: 0,
    iframeLeft: 0,
    iframeBottom: 0,
    iframeRight: 0,
  });
  const { pym } = usePym();

  const updateParentPositionInfo = useCallback((data: string) => {
    const parentInfo = parseParentInfo(data);

    setParentInfo({ ...parentInfo });
  }, []);

  const handleResize = useCallback(() => {
    if (pym) {
      pym.sendMessage('parentPositionInfo');
    }
  }, [pym]);

  useEffect(() => {
    if (pym) {
      // Provide the option {trackscroll: true} to the pym.Parent constructor to enable this message to be sent whenever the parent page scrolls
      pym.onMessage('viewport-iframe-position', updateParentPositionInfo);

      // Changes in content will cause the iframe to resize, so we need to manually request that the parent send us the position info
      window.addEventListener('resize', handleResize);
    }

    return () => {
      if (pym) {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [pym, handleResize, updateParentPositionInfo]);

  return parentInfo;
};
